<h3 mat-dialog-title class="title">{{ data.translations.title }}</h3>

<mat-dialog-content>
    <div class="messages">
      <txp-message [type]="messageType.DANGER"
                   data-qa-label="ErrorMessage"
                   *ngIf="showError">
        {{ 'boss.pos.associationModal.errorMessage' | translate }}
      </txp-message>
      <txp-message [type]="messageType.DANGER"
                   data-qa-label="ItemIdAlreadyExistsMessage"
                   *ngIf="itemAlreadyExistsError">
        {{ 'boss.pos.itemAlreadyExists' | translate }}
      </txp-message>
    </div>
    <div class="content">
        <div class="list">
            <txp-item-list
                class="item-list"
                [header]="data.translations.listTitle"
                [enableSelection]="true"
                [filterText]="filterText"
                [enableMultiSelect]="true"
                [hasCount]="true"
                [data]="itemsList"
                [entitiesSelectedText]="entitiesSelectedText"
                [hasTypeColumn]="!!data.itemTypeField"
                [typeKey]="data.itemTypeField"
                [typeAlign]="data.typeAlign"
                (emitSelection)="onSelected($event)"
                listKey="name"></txp-item-list>
        </div>
        <div class="actions">
            <i class="tce-icon-arrow-right arrow"></i>
            <txp-button [style]="buttonStyle.SECONDARY"
                        data-qa-label="AddSelectedButton"
                        (click)="addSelected()">
                {{ 'form.button.add' | translate }}
            </txp-button>
        </div>
        <div class="selected-list" [formGroup]="form">

            <mat-form-field *ngIf="data.item.name || data.editableName">
                <mat-label>{{data.translations.group}}</mat-label>
                <input matInput
                       required
                       [readonly]="data.substitutionMode || (data.item.type.toLowerCase() !== 'combo' && !data.editableName)"
                       formControlName="itemName">
              <mat-error>
                {{ 'form.error.required' | translate}}
              </mat-error>
            </mat-form-field>

            <div class="title">{{ data.translations.listTitle }}</div>

            <div class="items"
                 cdkDropList
                 (cdkDropListDropped)="onItemDrop($event)">
                <div *ngIf="!selectedItems.length" class="no-msg">
                    {{ noneSelectedMsg }}
                </div>
                <div *ngIf="formSubmitted && form.get('items')?.errors;" class="mat-error">
                  {{ 'form.error.minItems' | translate:{ count: 1 } }}
                </div>
                <div *ngFor="let item of selectedItems"
                     class="item"
                     cdkDrag
                     [cdkDragData]="item">
                    <span class="drag-icon" cdkDragHandle>
                      <i class="tce-icon-grip"></i>
                    </span>
                    <div class="name">
                      <div class="item-name">
                        {{item['name'] || item}}
                        <span *ngIf="item['typeIndicator']">
                          ({{ item['typeIndicator'] }})
                        </span>
                      </div>
                      <div class="item-sku"
                           title="{{item['skuNumber']}}">
                          {{item['skuNumber']}}
                      </div>
                    </div>
                    <div class="item-actions"
                         [class.store-mode]="!!data.selectedStore"
                         [class.combo-mode]="data.item.type.toLowerCase() === 'combo'"
                         [formGroup]="$any(form.get('items').get(item.itemId))"
                         *ngIf="form.get('items').get(item.itemId); let itemControl;">

                      <mat-slide-toggle *ngIf="data.selectedStore"
                                        data-qa-label="AvailableToggle"
                                        formControlName="available">
                      </mat-slide-toggle>

                      <ng-container *ngIf="!data.substitutionMode && data.item.type.toLowerCase() !== 'combo'">
                        <mat-form-field *ngIf="itemControl.get('editing').value" class="store-price">
                          <input matInput
                                 txpNumbersOnly
                                 required
                                 formControlName="price"
                                 data-qa-label="PriceInput">
                          <mat-error> {{ 'form.error.required' | translate }} </mat-error>
                        </mat-form-field>

                        <strong class="inherit-value" *ngIf="!itemControl.get('editing').value">
                          {{ 'boss.posEntities.inherit' | translate }}
                        </strong>

                        <a class="edit action"
                           *ngIf="!itemControl.get('editing').value"
                           (click)="onEdit(item)"
                           data-qa-label="EditButton"
                           [attr.title]="'form.button.edit' | translate">
                          <i class="tce-icon-edit edit-icon"></i>
                        </a>

                        <a class="revert action"
                           *ngIf="itemControl.get('editing').value"
                           (click)="onRevert(item)"
                           data-qa-label="RevertButton"
                           [attr.title]="'form.button.revert' | translate">
                          <i class="tce-icon-revert revert-icon"></i>
                        </a>
                      </ng-container>

                      <mat-form-field *ngIf="data.substitutionMode" class="surcharge-amount">
                        <mat-label>
                          {{ 'boss.pos.associationModal.surcharge' | translate }}
                        </mat-label>
                        <input matInput
                               txpNumbersOnly
                               formControlName="surchargeUseAmount"
                               data-qa-label="SurchargeAmount">
                      </mat-form-field>

                      <a class="substitute action"
                         *ngIf="data.item.type.toLowerCase() === 'combo'"
                         (click)="onChooseSubstitutes(item)"
                         data-qa-label="SubstitutesButton"
                         [attr.title]="'boss.pos.associationModal.substitutions' | translate">
                        <i class="tce-icon-share2 share-icon"></i>
                      </a>

                      <a class="delete action"
                         (click)="handleDelete(item)"
                         data-qa-label="DeleteButton"
                         [attr.title]="'form.button.remove' | translate">
                        <i class="tce-icon-trash remove-icon"></i>
                      </a>
                    </div>
                </div>

                <div *cdkDragPlaceholder></div>
            </div>

        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <txp-button [style]="buttonStyle.SECONDARY"
                [disabled]="isLoading"
                data-qa-label="CancelButton"
                (click)="handleCancel()">{{ 'form.button.cancel' | translate }}</txp-button>
    <txp-button [style]="buttonStyle.PRIMARY"
                [loading]="isLoading"
                data-qa-label="DoneButton"
                (click)="handleDone()">{{ 'form.button.done' | translate }}</txp-button>
</mat-dialog-actions>
